import React from 'react';
import { FiCopy } from 'react-icons/fi';
import ActionButton from './ActionButton';

const CopyButton = ({ onClick, title = "Copy", className = "" }) => {
  return (
    <ActionButton
      icon={FiCopy}
      onClick={onClick}
      title={title}
      className={className}
    />
  );
};

export default CopyButton;
